import { createContext, useContext, useEffect, useState, useCallback } from "react";
import api, { setUnauthorizedHandler } from "../lib/api";

const AuthCtx = createContext(null);

export const ROLE_LABELS = {
  owner: "Owner",
  ops: "Operations",
  lead_tech: "Lead Tech",
  tech_assistant: "Tech Assistant",
};

export const AuthProvider = ({ children }) => {
  // null = checking session, false = unauthenticated, object = authenticated user
  const [user, setUser] = useState(null);

  const refresh = useCallback(async () => {
    try {
      const { data } = await api.get("/auth/me");
      setUser(data);
      return data;
    } catch {
      setUser(false);
      return null;
    }
  }, []);

  useEffect(() => {
    setUnauthorizedHandler(() => setUser(false));
    refresh();
  }, [refresh]);

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    setUser(data.user);
    return data.user;
  };

  const logout = async () => {
    try {
      await api.post("/auth/logout");
    } catch {
      /* ignore */
    }
    setUser(false);
  };

  return (
    <AuthCtx.Provider value={{ user, login, logout, refresh }}>
      {children}
    </AuthCtx.Provider>
  );
};

export const useAuth = () => useContext(AuthCtx);
